import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CurrentDeputatesBySubjectTable } from '../../../../../components/Deputate/Tables/CurrentDeputatesBySubjectTable';
import { Page } from '../../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../../hooks/usePermissionChecker';

export const DeputateEvaluateCurrentBySubjectSubpage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  const handleRowClick = (subjectUuid: string) =>
    navigate(
      `/${t('routes.deputate.slug')}/${t('routes.plan.slug')}/${t(
        'routes.lessons.slug',
      )}/${t('routes.lessons.plan.subjects.slug')}/${subjectUuid}`,
    );

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <CurrentDeputatesBySubjectTable onRowClick={handleRowClick} />
    </Page>
  );
};
